<div class="tdo-time-input" style="height: 100%; display: flex; flex-direction: column; position: relative;" [ngStyle]="{'width': widthString}" data-cy="time-input-container">
  <ng-container *ngIf="placeholderPosition === 'above'">
    <div style="font-size: 12px; color: var(--tdo-primary); line-height: 0.8; flex-basis: fit-content;" data-cy="time-input-label">{{placeholder}}<span *ngIf="isRequired" style="color: red;" data-cy="time-input-required">*</span></div>
  </ng-container>
  <div style="display: flex;" data-cy="time-input-field-container">
    <input style="flex: 1;" *ngIf="placeholderPosition === 'inline' && innerValue" [min]="min" [max]="max" [value]="innerValue" [placeholder]="placeholder" disabled [required]="isRequired" data-cy="time-input-inline"/>
    <input style="flex: 1;" *ngIf="placeholderPosition !== 'inline' && innerValue" [min]="min" [max]="max" [value]="innerValue" disabled [required]="isRequired" data-cy="time-input"/>
    <div (click)="isShowDropdown = !isShowDropdown" style="flex-basis: fit-content; position: absolute; top: 3px; right: 0; font-size: 10px; cursor: pointer;" data-cy="time-input-toggle">  
      <mat-icon style="transform: scale(0.75, 0.75);" data-cy="time-input-icon">schedule</mat-icon>
    </div>
  </div>

  <div (appClickOutside)="isShowDropdown = false;" class="tdo-time-dropdown" [ngClass]="{'tdo-time-dropdown-show': isShowDropdown}" data-cy="time-input-dropdown">
    <mat-selection-list *ngIf="isShowDropdown" [multiple]="false" data-cy="time-input-list">    
      <mat-list-option *ngFor="let time of times" [value]="time" id="{{time.name}}" class="tdo-time-item"
                  [selected]="time.dateStr  === innerValue" 
                 (click)="onDateSelected(time)"
                 data-cy="time-input-option">
        {{time.dateStr}} 
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

